import React from 'react';
import { Link } from 'react-router';
import SEOHead from '../../components/seo/seo-head';
import { SEO_CONFIG } from '../../constants/seo-config';
import AppRoutes from '../../routes/routes';
import MarketingSubscribe from '../../components/homepage/marketing-subscribe';
import LoginStore from '../../stores/login-store';

// Facts here come from Dr Imam's Beacon Hospital and Cervino consultant profiles.
// The server-rendered copy and JSON-LD are in server/seo/marketing-config.js; keep both in step.
const MEMBERSHIPS = [
  'Irish Medical Council',
  'General Medical Council (UK)',
  'Royal College of Physicians of London',
  'Association of British Neurologists',
  'Irish Institute of Clinical Neuroscience',
  'South West of England Neurosciences Association',
  'Queen Square Alumni Association',
];

const PROFILES = [
  ['Beacon Hospital consultant profile', 'https://www.beaconhospital.ie/consultants/ibrahim-imam/'],
  ['Cervino consultant profile', 'https://cervino.ie/consultants/dr-ibrahim-imam/'],
  ['LinkedIn', 'https://ie.linkedin.com/in/ibrahimimam2000'],
];

export default class IbrahimImam extends React.Component {
  componentDidMount() {
    this.initReveal();
  }

  componentDidUpdate() {
    this.initReveal();
  }

  initReveal() {
    const reveals = document.querySelectorAll('.reveal:not(.visible)');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      reveals.forEach(el => io.observe(el));
    } else {
      reveals.forEach(el => el.classList.add('visible'));
    }
  }

  render() {
    return (
      <div className="new-homepage-wrapper">
        <SEOHead {...SEO_CONFIG.ibrahimImam} />

        {/* Header */}
        <div className="section" style={{ paddingTop: 112, textAlign: 'center' }}>
          <div className="eyebrow reveal" style={{ justifyContent: 'center' }}>
            <div className="eyebrow-line"></div>
            <span className="eyebrow-text">Author and reviewer</span>
            <div className="eyebrow-line"></div>
          </div>
          <h1 className="section-title reveal reveal-delay-1">
            Dr Ibrahim Imam<br /><em>MBBS, FRCP</em>
          </h1>
          <p className="section-sub reveal reveal-delay-2">
            Consultant Neurologist at Beacon Hospital, Sandyford, Dublin. He founded Neurochecklists
            and writes and reviews every checklist in the database.
          </p>
        </div>

        {/* Work */}
        <div className="section" style={{ paddingTop: 0 }}>
          <div className="feature-grid">
            <div className="feature-card reveal reveal-delay-1">
              <div className="feature-title">Neurochecklists</div>
              <div className="feature-desc">
                Author and reviewer of every checklist. Each checklist shows the date it was last reviewed,
                and every item links to its source. <Link to={AppRoutes.about}>About Neurochecklists</Link>.
              </div>
            </div>
            <div className="feature-card reveal reveal-delay-2">
              <div className="feature-title">Publications</div>
              <div className="feature-desc">
                More than 30 papers in peer-reviewed journals, and a chapter in the Oxford handbook
                Headache: A Practical Manual.
              </div>
            </div>
            <div className="feature-card reveal reveal-delay-3">
              <div className="feature-title">Books</div>
              <div className="feature-desc">
                700 Essential Neurology Checklists; Surfing the Brain: An Exploration of the Fringes of Neurology;
                Human Factors and Patient Safety: A Primer for Doctors and Medical Students.
              </div>
            </div>
          </div>
        </div>

        {/* Memberships and profiles */}
        <div className="section" style={{ paddingTop: 0 }}>
          <div className="feature-grid">
            <div className="feature-card reveal reveal-delay-1">
              <div className="feature-title">Registration and memberships</div>
              <ul className="feature-desc">
                {MEMBERSHIPS.map(name => <li key={name}>{name}</li>)}
              </ul>
            </div>
            <div className="feature-card reveal reveal-delay-2">
              <div className="feature-title">Also by Dr Imam</div>
              <div className="feature-desc">
                Host of The Neurology Lounge podcast and curator of The Doctors Bookshelf, a book review blog.
              </div>
            </div>
            <div className="feature-card reveal reveal-delay-3">
              <div className="feature-title">Profiles</div>
              <ul className="feature-desc">
                {PROFILES.map(([text, url]) => (
                  <li key={url}><a href={url} target="_blank" rel="noopener noreferrer">{text}</a></li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {LoginStore.isLoggedIn() ? null : <MarketingSubscribe />}
      </div>
    );
  }
}
